module.exports = __webpack_public_path__ + "img/20200415143306TIM截图20200415143120.32ed448f.png";